import "isomorphic-fetch";

const { Raven } = window;

let APIHandler;
export default APIHandler = {
  makeRequest: (request, settings, customErrorHandler) =>
    fetch(request, settings)
      .then((response) => {
        if (response.ok) {
          return response
            .json()
            .then((json) => json)
            .catch(() => false);
        }
        return { ok: response.ok, response };
      })
      .catch((err) => {
        if (customErrorHandler) {
          customErrorHandler(err);
        } else {
          // Raven.captureException('API call failed', { extra: { requestURL: request, requestSettings: settings, err } });
        }
        return false;
      }),

  ok: (response) => {
    if (Object.keys(response).length > 0) {
      return true;
    }
    return false;
  },

  timeout(ms, promise) {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        reject(new Error("timeout"));
      }, ms);
      promise.then(resolve, reject);
    });
  },

  getUser: (appId, email) => {
    const request = `https://accounts.travpromobile.com/api/v2/get_user/?email=${encodeURI(
      email
    )}&app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  loginFirebaseUser: (email, password) => {
    const request =
      "https://travpro.yourworldapps.nl/firebase-login.php?app=quark";
    const data = {
      email,
      password,
      type: "login",
    };

    const requestSettings = {
      method: "POST",
      body: JSON.stringify(data),
    };

    const onError = (err) => {
      // Raven.captureException('Firebase login failed', { extra: { requestURL: request, requestSettings, err } });
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(
      (res) => res
    );
  },

  registerFirebaseUser: (email, password) => {
    const request =
      "https://travpro.yourworldapps.nl/firebase-login.php?app=quark";
    const data = {
      email,
      password,
      type: "register",
    };

    const requestSettings = {
      method: "POST",
      body: JSON.stringify(data),
    };

    const onError = (err) => {
      // Raven.captureException('Firebase register failed', { extra: { requestURL: request, requestSettings, err } });
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(
      (res) => res
    );
  },

  forgotFirebasePassword: (email) => {
    const request =
      "https://travpro.yourworldapps.nl/firebase-login.php?app=quark";
    const data = {
      email,
      type: "forgot",
    };

    const requestSettings = {
      method: "POST",
      body: JSON.stringify(data),
    };

    const onError = (err) => {
      // Raven.captureException('Firebase register failed', { extra: { requestURL: request, requestSettings, err } });
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(
      (res) => res
    );
  },

  refreshFirebaseToken: (token) => {
    const request =
      "https://travpro.yourworldapps.nl/firebase-login.php?app=quark";
    const data = {
      refresh_token: token,
      type: "refresh",
    };

    const requestSettings = {
      method: "POST",
      body: JSON.stringify(data),
    };

    const onError = (err) => {
      // Raven.captureException('Firebase register failed', { extra: { requestURL: request, requestSettings, err } });
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(
      (res) => res
    );
  },

  getFirebaseData: (idToken) => {
    const request =
      "https://travpro.yourworldapps.nl/firebase-login.php?app=quark";
    const data = {
      idToken,
      type: "account",
    };

    const requestSettings = {
      method: "POST",
      body: JSON.stringify(data),
    };

    const onError = (err) => {
      // Raven.captureException('Firebase register failed', { extra: { requestURL: request, requestSettings, err } });
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(
      (res) => res
    );
  },

  setUser: (email, appId, params) => {
    // Format Date to dd-mm-yyyy, by adding a leading 0 and
    // slice last 2 characters to get Month and Day in two decimals.
    const date = new Date();
    const Month = `0${date.getMonth() + 1}`;
    const Day = `0${date.getDay()}`;
    const Year = date.getFullYear();
    const dateFormat = `${Year}-${Month.slice(-2)}-${Day.slice(-2)}`;

    let request = `https://accounts.travpromobile.com/api/v2/user/?
    email=${encodeURI(email)}&
    sales_companion_registered=${dateFormat}&
    app_id=${appId}&
    type_of_user=pro`;

    for (let i = 0; i < Object.keys(params).length; i += 1) {
      const objectName = Object.keys(params)[i];
      request += `&${objectName}=${encodeURI(params[objectName])}`;
    }
    return APIHandler.makeRequest(request);
  },

  setSfUser: (email, appId, params) => {
    // Format Date to dd-mm-yyyy, by adding a leading 0 and
    // slice last 2 characters to get Month and Day in two decimals.
    const date = new Date();
    const Month = `0${date.getMonth() + 1}`;
    const Day = `0${date.getDay()}`;
    const Year = date.getFullYear();
    const dateFormat = `${Year}-${Month.slice(-2)}-${Day.slice(-2)}`;

    let request = `https://taconnect.travpromobile.com/api/v3/salesforce/?
    email=${encodeURI(email)}&
    sales_companion_registered=${dateFormat}&
    app_id=${appId}&
    type_of_user=pro
    `;

    for (let i = 0; i < Object.keys(params).length; i += 1) {
      const objectName = Object.keys(params)[i];
      request += `&${objectName}=${encodeURI(params[objectName])}`;
    }
    return APIHandler.makeRequest(request);
  },

  updateSfUser: (appId, email, params) => {
    const parameters = params
      .map((p, i) => `${i > 0 ? "&" : ""}${p.param}=${p.val}`)
      .join("");
    const request = `https://taconnect.travpromobile.com/api/v3/salesforce/?email=${email}&${parameters}&app_id=${appId}`;
    return APIHandler.makeRequest(request, null, (err) => {
      // Raven.captureException('Updating user failed', { extra: { requestURL: request, requestSettings: null, err } });
    });
  },

  updateUser: (appId, email, params) => {
    const parameters = params
      .map((p, i) => `${i > 0 ? "&" : ""}${p.param}=${p.val}`)
      .join("");
    const request = `https://accounts.travpromobile.com/api/v2/user/?email=${email}&${parameters}&app_id=${appId}`;
    return APIHandler.makeRequest(request, null, (err) => {
      // Raven.captureException('Updating user failed', { extra: { requestURL: request, requestSettings: null, err } });
    });
  },

  updateRegisterUser: (appId, email, params) => {
    let request = `https://accounts.travpromobile.com/api/v2/user/?email=${email}&app_id=${appId}`;
    for (let i = 0; i < Object.keys(params).length; i += 1) {
      const objectName = Object.keys(params)[i];
      request += `&${objectName}=${encodeURI(params[objectName])}`;
    }
    return APIHandler.makeRequest(request);
  },

  updateSearchIndex: (appId) => {
    const request = `https://search.travpromobile.com/updateindex_v2.php?app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getSearchResults: (appId, query) => {
    const request = `https://stack.travpromobile.com/query_v2.php?app_id=${appId}&q=${encodeURIComponent(
      query
    )}`;
    return APIHandler.makeRequest(request);
  },

  getUserProgress: (appId, email) => {
    let request = `https://progress.travpromobile.com/progress_user_v2/?email=${encodeURI(
      email
    )}`;
    if (["number", "string"].includes(typeof appId)) {
      request += `&app_id=${appId}`;
    }
    if (typeof appId === "object") {
      appId.forEach((id) => {
        request += `&app_id[]=${id}`;
      });
    }
    return APIHandler.makeRequest(request);
  },

  registerUserProgress: (email) => {
    const request = "https://progress.travpromobile.com/users/";
    const requestSettings = {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      timeout: 5000,
      body: JSON.stringify({ user: { email } }),
    };

    const onError = (err) => {
      // Raven.captureException('Registering user progress failed', { extra: { requestURL: request, requestSettings, err } });
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(
      (res) => {
        if (res.status !== 422) {
          return res;
        }
        return false;
      }
    );
  },

  getFavoriteContent: (favorites) => {
    const request = "https://cms.travpromobile.com/api/app/favorites/?";
    let params = "";

    favorites.forEach((item) => {
      if (item.type === "p") {
        params += `page[]=${item.unid}&`;
      } else {
        params += `page[]=${item.type}${item.unid}&`;
      }
    });

    return APIHandler.makeRequest(`${request}${params}`);
  },

  getFavorite: (appId, email) => {
    const request = `https://progress.travpromobile.com/favorites_by_app/${appId}/?email=${email}`;
    return APIHandler.makeRequest(request);
  },

  addFavorite: (params) => {
    const request = "https://progress.travpromobile.com/favorites/";
    return APIHandler.makeRequest(request, {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      timeout: 5000,
      body: JSON.stringify(params),
    });
  },

  removeFavorite: (params) => {
    const request = "https://progress.travpromobile.com/favorites";

    return APIHandler.makeRequest(request, {
      headers: {
        "Content-Type": "application/json",
      },
      method: "DELETE",
      timeout: 5000,
      body: JSON.stringify(params),
    });
  },

  setUserProgress: (params) => {
    const request = "https://progress.travpromobile.com/progress";

    const requestObject = {
      chapter_id: params.chapterId,
      lastpage: params.lastPage,
      progress: params.progress,
      email: params.email,
    };

    const valid = Object.values(requestObject).every((param) => param);
    const NaNCheck = +requestObject.lastpage && +requestObject.progress;
    const positive =
      +requestObject.lastpage >= 0 && +requestObject.progress >= 0;

    if (valid && NaNCheck && positive) {
      return APIHandler.makeRequest(request, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        timeout: 5000,
        body: JSON.stringify(requestObject),
      });
    }
    return new Promise((resolve) =>
      resolve(new Error("One of the supplied values was invalid."))
    );
  },

  getLocation: () => {
    const request = "https://pro.ip-api.com/json?key=lsCvt9AP5YqiVgL";
    return APIHandler.makeRequest(request);
  },

  getMessage: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/message/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getAnnouncement: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/notification/true/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getUnreadMessages: (appId, lastChecked) => {
    const request = `https://cms.travpromobile.com/api/app/latest_message/?app_id=${appId}&date=${lastChecked}`;
    return APIHandler.makeRequest(request);
  },

  getChapters: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/chapter-info/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getFastFacts: (appId, email) => {
    const request = `https://cms.travpromobile.com/api/app/sales-companion/?app_id=${appId}&type=fastfacts&format=json&email=${email}`;
    return APIHandler.makeRequest(request);
  },

  getToolbox: (appId, email) => {
    const request = `https://cms.travpromobile.com/api/app/sales-companion/?app_id=${appId}&type=toolbox&format=json&email=${email}`;
    return APIHandler.makeRequest(request);
  },

  getContacts: (appId) => {
    const request = `https://cms.travpromobile.com/api/contact-us?app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getTrainingPages: (chapterId) => {
    const request = `https://cms.travpromobile.com/api/app/chapter-content/?chapter_id=${chapterId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getDLC: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/getDLC/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getVideos: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/carousel-video/?app_id=${appId}&type=both&autoPlay=true&format=json&app=new`;
    return APIHandler.makeRequest(request);
  },

  getImages: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/carousel-photo?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getCollection: (itemID) => {
    const request = `https://cms.travpromobile.com/api/app/collection?sales_companion_item_id=${itemID}`;
    return APIHandler.makeRequest(request);
  },

  getNamedCollection: (title, appId) => {
    const request = `https://cms.travpromobile.com/api/app/named-collection?title=${title}&app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  getAppQuestions: (chapterId) => {
    const request = `https://cms.travpromobile.com/api/app/chapter-content/?chapter_id=${chapterId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getDownloadURL: (file, name) => {
    let downloadURL = `https://stack.travpromobile.com/download.php?url=${file}`;
    if (name) {
      downloadURL += `&name=${name}`;
    }
    return downloadURL;
  },

  getAppInfo: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/app-info/?app_id=${appId}&format=json`;
    return APIHandler.makeRequest(request);
  },

  getSubApps: (appId) => {
    const request = `https://cms.travpromobile.com/api/app/subApps/?format=json&app_id=${appId}`;
    return APIHandler.makeRequest(request);
  },

  setChapterCompleted: (appId, email, chapterId, chapterNumber) => {
    const request = "https://crm.travpromobile.com/api/chapter";
    const data = {
      app_id: appId,
      email,
      chapter_id: chapterId,
      chapter_number: chapterNumber,
    };

    const requestSettings = {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(data),
    };

    const onError = (err) => {
      console.log(err);
    };

    return APIHandler.makeRequest(request, requestSettings, onError).then(
      (res) => res
    );
  },

  trackEvent: (appId, email, category, name, value) => {
    const action = "click";
    const request = "https://crm.travpromobile.com/api/event";
    const data = {
      app_id: appId,
      email,
      action,
      category,
      name,
      value,
    };

    const formData = new FormData();
    for (const item in data) {
      formData.append(item, data[item]);
    }

    const requestSettings = {
      method: "POST",
      timeout: 5000,
      body: formData,
    };

    return APIHandler.makeRequest(request, requestSettings).then(() => false);
  },
};
